import { c as _c } from "react/compiler-runtime";
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from 'react';
interface Props {
  errors: Record<string, any>;
  setErrors: Dispatch<SetStateAction<Record<string, any>>>;
}
export const StoreEditItemContext = createContext<Props | null>(null);
export const StoreEditItemProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [errors, setErrors] = useState(t1);
  let t2;
  if ($[1] !== errors) {
    t2 = {
      errors,
      setErrors
    };
    $[1] = errors;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const value = t2;
  let t3;
  if ($[3] !== children || $[4] !== value) {
    t3 = <StoreEditItemContext.Provider value={value}>{children}</StoreEditItemContext.Provider>;
    $[3] = children;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const useStoreEditItemContext = () => {
  const context = useContext(StoreEditItemContext);
  if (!context) {
    throw new Error("useStoreEditItemContext must be used within a StoreEditItemProvider");
  }
  return context;
};